export const loading = 'loading';
